


  import dep0 from "@ember-data/adapter/-embroider-implicit-modules.js";
  import dep1 from "@ember-data/debug/-embroider-implicit-modules.js";
  import dep2 from "@ember-data/graph/-embroider-implicit-modules.js";
  import dep3 from "@ember-data/json-api/-embroider-implicit-modules.js";
  import dep4 from "@ember-data/legacy-compat/-embroider-implicit-modules.js";
  import dep5 from "@ember-data/model/-embroider-implicit-modules.js";
  import dep6 from "@ember-data/request/-embroider-implicit-modules.js";
  import dep7 from "@ember-data/request-utils/-embroider-implicit-modules.js";
  import dep8 from "@ember-data/serializer/-embroider-implicit-modules.js";
  import dep9 from "@ember-data/store/-embroider-implicit-modules.js";
  import dep10 from "@ember-data/tracking/-embroider-implicit-modules.js";
  import dep11 from "@warp-drive/core-types/-embroider-implicit-modules.js";
  import dep12 from "@embroider/macros/-embroider-implicit-modules.js";


export default Object.assign({},
    dep0,
    dep1,
    dep2,
    dep3,
    dep4,
    dep5,
    dep6,
    dep7,
    dep8,
    dep9,
    dep10,
    dep11,
    dep12,
  {
  }
);
